module.exports = __webpack_public_path__ + "media/embeds/icons/powered_by-93c521cdc4b97fc0970ad05aae151856.png";